/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".friend[_ngcontent-%COMP%]{padding:1rem;background:#f8f9fa;overflow:hidden;clear:both}.friend[_ngcontent-%COMP%]:nth-child(2n){background:none}.friend[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{overflow:hidden;clear:both}.friend[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:128px;height:auto;float:left;margin-right:1rem}.friend[_ngcontent-%COMP%]   .jump-btn[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/friends/friends.component.scss.shim.ngstyle.js.pre-build-optimizer.js